import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function Priser() {
  const [groupedPrices, setGroupedPrices] = useState({});

  useEffect(() => {
    axios.get(`${API_URL}/api/prices/all`)
      .then(response => {
        const groups = response.data.reduce((acc, price) => {
          const category = price.category_name;
          if (!acc[category]) { acc[category] = []; }
          acc[category].push(price);
          return acc;
        }, {});
        setGroupedPrices(groups);
      })
      .catch(error => console.error("Error fetching prices:", error));
  }, []);

  return (
    <div>
      <Helmet>
        <title>Priser - Sunnfjord Naprapatsenter</title>
        <meta name="description" content="Se vår komplette prisliste for naprapatbehandling, treningsveiledning og andre tjenester hos Sunnfjord Naprapatsenter i Førde." />
      </Helmet>
      <h1>Priser</h1>
      {Object.keys(groupedPrices).map(category => (
        <div key={category} className="price-category-section">
          <h2 className="price-category-header">{category}</h2>
          <table className="price-table">
            <thead>
              <tr>
                <th>Tjeneste</th>
                {/* --- VIKTIG ENDRING HER --- */}
                <th>Detaljer</th>
                <th>Pris</th>
              </tr>
            </thead>
            <tbody>
              {groupedPrices[category].map(item => (
                <tr key={item.id}>
                  <td data-label="Tjeneste">{item.service_name}</td>
                  <td data-label="Detaljer">{item.details}</td>
                  <td data-label="Pris">{item.price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}

export default Priser;